import { ThemeProvider } from '@deltasierra/components';
import * as React from 'react';
import { withAngularIntegration } from '../../../../common/componentUtils/reactComponentRegistration';
import { BlockedPreviewsWell } from './BlockedPreviewsWell';

function AdminTemplatePreviewsPage(): JSX.Element {
    return (
        <ThemeProvider>
            <BlockedPreviewsWell />
        </ThemeProvider>
    );
}
AdminTemplatePreviewsPage.displayName = 'AdminTemplatePreviewsPage';

export const AdminTemplatePreviewsPageAngular = withAngularIntegration(
    AdminTemplatePreviewsPage,
    'adminTemplatePreviewsPage',
    {},
);
